// extracted by mini-css-extract-plugin
export default {"title":"SectionTitle_title__KQIau","swoosh":"SectionTitle_swoosh__lOhzu"};